<template>
    <div>
        <img style="width: 100%" src="../assets/imgs/health1.png" alt="">
    </div>
  </template>
  <script>
  import { mapState } from 'vuex';
  import { getUrlParams } from '@/utils';
  import server from '@/server/index';
  import store from '@/store';
  export default {
    data() {
      return {
        showGame: false,
        linkUrl: '',
      };
    },
    computed: {
    },
    created() {
        console.log('aaaa')
    },
    methods: {
      closeUserLink() {
        this.linkUrl = '';
      },
    },
  };
  </script>
  <style>
  .gameState p{font-size:14px;color: #000;}
  </style>
  